export const getDropdownFilterTemperature = () => {
    return {
        i18n: "installationoverview.temperature",
        label: "Temperature",
        id: "temperature",
        options: [
            {
                type: "check",
                variable: "type",
                options: [
                    {
                        id: "Battery-1",
                        i18n: "installationoverview.temperature_type_battery",
                        label: "Battery",
                        variable: "Battery",
                        value: false
                    },
                    {
                        id: "Fridge-2",
                        i18n: "installationoverview.temperature_type_fridge",
                        label: "Fridge",
                        variable: "Fridge",
                        value: false
                    },
                    {
                        id: "Generic-3",
                        i18n: "installationoverview.temperature_type_generic",
                        label: "Generic",
                        variable: "Generic",
                        value: false
                    },
                    {
                        id: "Others",
                        i18n: "installationoverview.temperature_type_others",
                        label: "Others",
                        variable: "Others",
                        value: false
                    }
                ]
            },
            {
                type: "minMax",
                i18n: "installationoverview.temperature",
                label: "Temperature",
                variable: "temperature",
                min: "",
                max: "",
                measure: "celsius" // used with class ::before
            }
        ]
    };
};